Object.defineProperty(exports, "__esModule", { value: true });
exports.naturaDarkColorTokens = exports.naturaLightColorTokens = void 0;
var natura_light_1 = require("./natura-light");
Object.defineProperty(exports, "naturaLightColorTokens", { enumerable: true, get: function () { return natura_light_1.naturaLightColorTokens; } });
var natura_dark_1 = require("./natura-dark");
Object.defineProperty(exports, "naturaDarkColorTokens", { enumerable: true, get: function () { return natura_dark_1.naturaDarkColorTokens; } });
//# sourceMappingURL=index.js.map